import React, { useImperativeHandle } from 'react'

import { B2, Button, H5, Stack } from '@zet/design-system'
import { BottomSheet } from '@zet/design-system/bottomSheet'

import { ICON_MAP } from '../../../../utils/iconMap'

const UNLINKED_ICON = ICON_MAP['UNLINKED']

export interface PanAadhaarNotLinkedHandler {
  openModal: () => void
  closeModal: () => void
}

export default React.forwardRef<PanAadhaarNotLinkedHandler, any>(
  function PanAadhaarNotLinked(props, ref) {
    const [visible, setVisible] = React.useState(true)

    useImperativeHandle(ref, () => ({
      closeModal: () => {
        closeBottomSheet()
      },
      openModal: () => {
        setVisible(true)
      },
      isVisible: () => {
        return visible
      },
    }))
    const closeBottomSheet = () => {
      setVisible(false)
    }

    return (
      <BottomSheet
        visible={visible}
        onDismiss={closeBottomSheet}
        disableBottomSheet={closeBottomSheet}
        sheetName="pan_aadhaar_not_linked"
      >
        <Stack>
          <Stack className="items-center px-4 py-6">
            <UNLINKED_ICON className="mb-3" />
            <H5 className="text-center">
              {'Your PAN and Aadhar are not linked'}
            </H5>
            <B2 className="text-center">
              {
                'Seems like your PAN and Adhaar are not linked. Please link your PAN and Aadhaar.'
              }
            </B2>
          </Stack>
          <Stack className="border-grays-30 w-full border-t px-4 py-3">
            <Button
              loading={props?.isLoading}
              size="lg"
              fullWidth
              onPress={props?.onContinuePress}
            >
              {'OK and Continue'}
            </Button>
          </Stack>
        </Stack>
      </BottomSheet>
    )
  }
)
